import { useMutation } from '@tanstack/react-query';
import { ApiConfig } from '@/config/api.config';
import { TransactionType } from '@/features/transactions/types/transactions-dto';
import { useAxiosAuth } from '@/hooks/useAxiosAuth.ts';
import { DateTimeHelper } from '@/utils/dateTimeHelper';

type Props = {
    startDate: Date;
    endDate: Date;
    ownerId?: string;
    apartmentId?: {
        id: string;
        name?: string;
    }[];
    account?: TransactionType | null;
};

export const useTransactionDownloadInvoicesApi = () => {
    const axiosInstance = useAxiosAuth();

    const {
        mutateAsync: downloadInvoices,
        isPending: isPendingDownloadInvoices,
        isError: isErrorDownloadInvoices,
    } = useMutation({
        mutationFn: async (params: Props) => {
            const apartmentIds = params.apartmentId?.map((apartment) => apartment.id);

            const url = ApiConfig.queries.features.transactions.endpoints.downloadInvoices;
            const response = await axiosInstance.get(url, {
                params: {
                    startDate: DateTimeHelper.getDateOnly(params.startDate),
                    endDate: DateTimeHelper.getDateOnly(params.endDate),
                    ownerId: params.ownerId,
                    apartmentId: apartmentIds,
                    account: params.account,
                },
                responseType: 'blob',
            });
            return response.data as Blob;
        },
    });

    return {
        downloadInvoices,
        isPendingDownloadInvoices,
        isErrorDownloadInvoices,
    };
};
